import { render, staticRenderFns } from "./ActiveSuspensionLeft.vue?vue&type=template&id=36ac1df6&scoped=true&"
import script from "./ActiveSuspensionLeft.vue?vue&type=script&lang=js&"
export * from "./ActiveSuspensionLeft.vue?vue&type=script&lang=js&"
import style0 from "./ActiveSuspensionLeft.vue?vue&type=style&index=0&id=36ac1df6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac1df6",
  null
  
)

export default component.exports